<template>
  <div class="register">
    <van-sticky>
      <div class="mr-tab-wrapper">
        <div class="mr-tab"><div v-for="item in tabs" :key="item.id" class="tab" :class="{ 'active': activeName === item.id}" @click="toggleTab(item.id)">{{ item.name }}</div></div>
        <span v-if="isPlus" class="back-btn iconfont icon-houtui fs-24 fw-700" @click="$router.replace({ path: '/login', query: $route.query })"></span>
      </div>
    </van-sticky>
    <div class="form">
      <component :is="activeName" :count="countNum" @sendSms="sendSms" @finished="finished"></component>
      <div>
        <van-button :loading="loading" color="#FC3159" class="login-btn mt-24 border-radius" :disabled="!isActive" loading-text="加载中..." @click="register">注册</van-button>
        <div class="flex align-center mt-15"><van-checkbox v-model="checked" shape="square" class="mr-8"></van-checkbox>同意 <router-link tag="span" to="/help/detail?pid=2&id=5&title=平台使用协议" class="color-0079FF">《用户协议》</router-link>及<router-link tag="span" to="/help/detail?pid=2&id=5&title=平台使用协议" class="color-0079FF"></router-link><router-link tag="span" to="/help/detail?pid=2&id=22&title=隐私政策" class="color-0079FF">《隐私政策》</router-link></div>
        <a v-if="!isPlus" class="mt-15 color-0079FF download-btn" href="//x5.kkkmusic.com/activity.html#/download-app"><van-icon name="down" />点击进行下载App</a>
      </div>
    </div>
  </div>
</template>

<script>
import MrSingle from './single'
import MrCompany from './company'
import { smsSend } from '@/api/common.js'
import { register } from '@/api/register'
import { validPassword } from '@/utils/validate'
import { mapState } from 'vuex'
import md5 from 'js-md5'
import Realidcation from '@/mixins/realidcation-verifyurl.js'
export default {
  name: 'Register',
  mixins: [Realidcation],
  components: { MrSingle, MrCompany },
  data() {
    return {
      loading: false,
      timer: null, // 倒计时
      countNum: 60,
      activeName: 'MrSingle',
      agent_uid: '', // 代理商ID
      team_role: '', // 关系：与主体关系
      checked: false,
      isActive: false, // 是否可以提交
      form: {}
    }
  },
  computed: {
    tabs() {
      return [
        { name: '个人注册', id: 'MrSingle' },
        { name: '企业注册', id: 'MrCompany' },
      ]
    },
    ...mapState(['isPlus'])
  },
  methods: {
    toggleTab(id) {
      this.activeName = id
    },
    async sendSms() {
      this.countNumAuto()
      try {
        const res = await smsSend({ mobile: this.form.mobile, event: 'register' })
        if (res.code === 1) {
          this.$toast.success(res.msg)
        }
      } catch(err) {
        clearInterval(this.timer)
        this.countNum = 60 // 重新赋值
      } finally {
        this.loading = false
      }
    },
    countNumAuto() { // 倒计时
      this.countNum--;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countNum--;
        if (this.countNum < 1) {
          clearInterval(this.timer);
          this.countNum = 60;
        }
      }, 1000)
    },
    finished(evt) {
      this.isActive = evt.isFinished && this.checked && true || false
      this.form = evt.form
    },
    async register() {
      if (!validPassword(this.form.password)) {
        this.$toast('请输入8-20位密码，字母/数字/符号至少2种')
        return
      }
      this.loading = true
      const params = {
        ...this.form,
        gid: this.activeName === 'MrSingle' ? 1 : 2,
        agent_uid: this.$route.query.agent_uid || this.$store.state.agent.id, // 代理商ID
        password: md5(this.form.password),
        source: this.$route.query.source || null
      }
      try {
        const res = await register(params)
        this.$toast.success(res.msg)
        // 注册成功后，调用法大大实名认证接口,无需判断是否已实名
        if (!this.isPlus) { // H5内打开的，需要清空token，并打开发大大页面地址链接
          this.$store.dispatch('logout')
          const data = await this.getRealidcation()
          location.href = data.url
        } else { // App内部的跳转逻辑
          localStorage.clear()
          this.$store.commit('SET_ROLE', 0)
          let url = location.origin + '?_platform=android'
          location.href = url + '#/home'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.back-btn{
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
}
.mr-tab-wrapper{
  width: 100%;
  background-color: #fff;
}
.mr-tab{
  width: 186px;
  height: 62px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  .tab{
    position: relative;
    color: #B7BDCA;
    width: 80px;
    text-align: center;
    padding-bottom: 5px;
    box-sizing: content-box;
    transition: all .2s;
    &:after{
      content: "";
      position: absolute;
      bottom: 0;
      width: 30px;
      height: 3px;
      left: 50%;
      transform: translateX(-50%);
      transition: all .2s;
      background-color: rgba(0, 0, 0, 0);
      border-radius: 3px;
    }
    &.active{
      color: #0D0E15;
      &:after{
        background-color: #ee0a24;
      }
    }
  }
}
.form{
  padding-bottom: 20px;
  margin-top: 0;
  color: #0D0E15;
  .input{
    input{
      font-size: 14px;
      color: #0D0E15;
    }
  }
}
</style>
